//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from "../../store";
import sa from "sa-sdk-javascript";
import { mapGetters, mapState } from "vuex";
import AppMain from "./AppMain";
import FormulaHeader from "./components/header";
import FormulaBottm from "./components/buttom";
import FormulaTopDesc from "./components/topDesc";
import pageAddEventListener from "./../../utils/eventListener";
import {
  getCollectInfoById,
  getCollectInfoByIdYsz,
} from "./../../server/home/index";
import {
  formulaDetailReport
} from "../../server/oldformula/index"
import { getUrlParam } from "./../../utils/common";
// import nativeToWeb from '../../../static/js/nativeToWeb'
export default {
  name: "layout",
  components: {
    AppMain,
    FormulaHeader,
    FormulaTopDesc,
    FormulaBottm,
  },
  data() {
    return {
      isCollect: false,
      formulaViewSource: "", // 神策埋点来源 1-搜索，2-分类列表，3-收藏，4-浏览记录，5-分享，6-H5回流（短信），7-直接访问，8-站内信，9-Push，26-站内跳转，29-首页数据更新
      isTool: false,
    };
  },
  mounted() {
    const ua = navigator.userAgent.toLowerCase();
    this.isTool = ua.indexOf("tool") > -1;
    this.$nextTick(() => {
      pageAddEventListener();
      this.getFormulaInfo();
    });
  },
  created() {
    hiddenTitleBar(true);
    if (this.$route.query.code == 4004) {
      this.$router.push({
        path: "/delete",
        query: {
          type: "公式",
        },
      });
    }
    setTimeout(()=>{
      this.detailReport()
    },1000)
   
  },
  computed: {
    ...mapGetters(["isWeChat"]),
    loginStatus: () => {
      return store.state.login.loginStatus;
    },
  },
  methods: {
    detailReport() {
      const YszAppInfo = JSON.parse(localStorage.getItem('YszAppInfo'))
      console.log('YszAppInfo-detailReport', YszAppInfo)
      const params = {
        formulaId:this.$route.query.id,
        uid:this.$route.query.uid ? this.$route.query.uid : YszAppInfo && YszAppInfo.uid ? YszAppInfo.uid : -1
      }
      formulaDetailReport(params).then(res=>{
        console.log(res,'上报结果');
        
      })
      .catch(err=>{
        console.log(err);
        
      })
    },
    // 判断是否收藏
    getFormulaInfo() {
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        return;
      }
      let self = this;
      let urlData = self.$route.query;
      // self.changeSCDataAttributes()
      let obj = {
        uuid: urlData.id,
        collectType: "FORMULA", // 收藏类型( DRUG,GUIDE,FORMULA,NEWS)
        contentType: 0,
      };
      let isYsz = navigator.userAgent.indexOf("ysz") > -1;
      if (isYsz) {
        console.log(urlData, "formulaId1");
        let objYsz = {
          formulaId: urlData.formulaId ? urlData.formulaId : urlData.id,
          formulaViewSource: 7,
        };
        getCollectInfoByIdYsz(objYsz)
          .then((res) => {
            console.log(res, "formulaId56565656");
            self.isCollect = res.flag;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        getCollectInfoById(obj)
          .then((res) => {
            self.isCollect = res.result;
          })
          .catch((err) => {
            console.log(err);
          });
        sa.track("v1_tool_viewFormulaDetail", {
          tool_contentID: urlData.id,
          tool_contentName: this.$route.meta.title,
          tool_viewSource: urlData.source,
        });
      }
    },
    // 修改神策数据属性
    changeSCDataAttributes() {
      let self = this;
      let urlData = self.$route.query;
      if (
        getUrlParam("from") === "timeline" ||
        getUrlParam("from") === "singlemessage"
      ) {
        // 来自 分享 并且是 朋友圈或好友
        this.formulaViewSource = 5;
      } else if (urlData.formulaViewSource) {
        this.formulaViewSource = Number(urlData.formulaViewSource);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from);
    // this.getFormulaInfo()
    next();
  },
  watch: {
    $route(to, from) {},
    loginStatus: {
      handler() {
        localStorage.getItem("token") &&
          !localStorage.getItem("token") == "" &&
          this.getFormulaInfo();
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/layout/layout.vue